<template>
  <div class="flex flex-col gap-5 p-5">
    <p class="text-body-large-m">{{ t("bulk_tickets.added", result.added.length + result.attached.length) }}</p>
    <NuxtLink v-if="result.ticket_id" :to="{ name: 'tickets-id', params: { id: result.ticket_id } }" @click="close">
      <Button :variant="ButtonVariant.Primary" class="w-full">
        {{ t("go_to_entity", { entity: t("ticket", 1).toLowerCase() }) }}
      </Button>
    </NuxtLink>
    <div v-for="group in groups" :key="group.key" class="flex flex-col gap-2">
      <p class="text-body-default-m">{{ t(`bulk_tickets.${group.key}`, group.items.length) }}</p>
      <div
        v-for="item in group.items"
        :key="item.package_number"
        class="border-bdr-subtle flex items-center justify-between gap-3 rounded-lg border px-3 py-2"
      >
        <span class="text-body-default truncate">{{ item.package_number }}</span>
        <NuxtLink
          v-if="item.ticket_id"
          :to="{ name: 'tickets-id', params: { id: item.ticket_id } }"
          class="text-body-default shrink-0 underline"
          @click="close"
        >
          {{ t("go_to_entity", { entity: t("ticket", 1).toLowerCase() }) }}
        </NuxtLink>
        <span v-else-if="item.reason" class="text-body-default text-fgr-secondary">{{ item.reason }}</span>
      </div>
    </div>
    <Button :variant="ButtonVariant.Secondary" @click="$emit('reset')">{{ t("bulk_tickets.create_more") }}</Button>
  </div>
</template>

<script setup lang="ts">
  import type { BulkTicketResult } from "~/types/ticket";

  const { result } = defineProps<{ result: BulkTicketResult }>();
  defineEmits<{ reset: [] }>();

  const { t } = useI18n();

  const groups = computed(() =>
    [
      // Moved into this case, so a link to the old ticket would only lead back here
      { key: "attached", items: result.attached.map(({ package_number }) => ({ package_number })) },
      { key: "existing", items: result.existing },
      { key: "not_found", items: result.not_found.map((package_number) => ({ package_number })) },
      { key: "ineligible", items: result.ineligible },
    ].filter((group) => group.items.length)
  );

  const close = () => EventBus.$emit("CREATETICKET_CLOSE");
</script>
